import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';

export interface paginationAttribute {
  totalItems: number,
  currentPage: number,
  pages: number[],
  endPage: boolean,
  pageCount: number,
  endPageNumber: number
}

@Component({
  selector: 'app-generic-pagination',
  templateUrl: './generic-pagination.component.html',
  styleUrls: ['./generic-pagination.component.css']
})

export class GenericPaginationComponent implements OnChanges {

  @Input() pagination: paginationAttribute;
  @Input() backgroundColor: string;

  @Output() paginationAction = new EventEmitter<any>();

  constructor() { }

  ngOnChanges() {
    this.setPaginationAttributes();
  }

  /**
   * Sets pagination attributes
   */
  setPaginationAttributes() {
    const endPageLimit = (this.pagination?.['totalItems'] / this.pagination?.['pageCount']);
    if (((endPageLimit % 1) > 0)) {
      if (Math.trunc(endPageLimit) >= 1) {
        this.pagination['endPageNumber'] = Math.trunc(endPageLimit) + 1;
      } else {
        this.pagination['endPageNumber'] = 1;
      }
    } else {
      this.pagination['endPageNumber'] = Math.trunc(endPageLimit);
    }
  }


  /**
   * Determines whether paginate change on
   * @param pageNumber 
   */
  onPaginateChange(pageNumber: number) {
    this.paginationAction.emit(pageNumber);
  }

}
